<app-auth-connect-header></app-auth-connect-header>
<div class="form-body">
  <form #authForm="ngForm" (ngSubmit)="signIn(authForm)">
    <div class="email fields">
      <app-input
        [type]="'email'"
        name="email"
        [formGroup]="authForm"
        [(ngModel)]="userProfile.email"
        label="Email"
        [placeholder]="'Email'"
        required
        [pattern]="submitted?emailRegex:''"
        [isEditable]="true"
      ></app-input>
    </div>
    <div class="password-section fields" id="password-section">
      <app-input
        [type]="'password'"
        name="password"
        [(ngModel)]="userProfile.pass"
        [formGroup]="authForm"
        label="Password"
        [placeholder]="'Password'"
        required
      ></app-input>
      <div class="l-body-sm-bold text-end">
        <a (click)="navigate('forgot')" class="forget-password tertiary-button">Forgot password</a>
      </div>
    </div>

    <!-- action -->
    <div class="submitButton">
      <button
        class="p-button l-form-button l-body-bold"
        type="submit"
        [disabled]="!authForm.valid && authForm.touched"
      >
        Log in
      </button>

      <app-toast></app-toast>

      <!-- SSO -->
      <ng-container
        *ngFor="let x of SSO_val"
        [ngTemplateOutlet]="SSObutton"
        [ngTemplateOutletContext]="{ ssoVal: x }"
      >
      </ng-container>

      <!-- dummy hidden button to add space for avoiding chat button overlap with other button -->
      <div style="visibility: hidden">
        <ng-container
          [ngTemplateOutlet]="SSObutton"
          [ngTemplateOutletContext]="{ ssoVal: { img: '', name: 'dummy' } }"
        >
        </ng-container>
      </div>
    </div>
  </form>
</div>
